import { css } from "@emotion/react";
import React from "react";
import { useSearchParams } from "react-router-dom";
import ServiceNoticeForUser from "../../../components/expert/serviceNotice/ServiceNoticeForUser";
import ServiceNoticeForExpert from "../../../components/expert/serviceNotice/ServiceNoticeForExpert";
import { transferToNative } from "@src/lib/WebAppBridge";
import backIcon from "@src/assets/ico_arrow_back.png";
export enum ExpertServiceType {
    "경매대행" = 1, //매물컨설팅 + 매수신청대리
    "매수신청대리" = 2,
    "매물컨설팅" = 3,
    "임장동행" = 4,
    "미납관리" = 5,
}
const ExpertServiceNotice = () => {
    const [seachParams] = useSearchParams();
    const serviceType = seachParams.get("serviceType") as unknown as ExpertServiceType;
    const isTakerNotice = seachParams.get("userType") === "taker";

    return (
        <div css={rootBoxStyle}>
            <div css={titleBoxStyle}>
                <img
                    src={backIcon}
                    width={14}
                    height={20}
                    alt="뒤로 가기"
                    className="back-icon"
                    onClick={() => {
                        transferToNative("done", "closeWebView");
                    }}
                />

                <div className="title">전문가 {isTakerNotice ? "등록" : "매칭"} 서비스</div>
            </div>
            {isTakerNotice ? (
                <ServiceNoticeForExpert serviceType={serviceType ?? ExpertServiceType.경매대행} />
            ) : (
                <ServiceNoticeForUser serviceType={serviceType ?? ExpertServiceType.경매대행} />
            )}
        </div>
    );
};

export default ExpertServiceNotice;

const rootBoxStyle = css`
    width: 100%;
    height: 100vh;
    overflow: hidden auto;
    position: relative;

    & > img {
        width: 100%;
    }

    & > button {
        position: fixed;
        z-index: 100;
        font-size: 26px;
        padding: 10px 48px;
        border-radius: 100px;
        bottom: 80px;
        transform: translateX(-50%);
        white-space: nowrap;
        left: 50%;
        background: rgb(0, 71, 255);
        box-shadow: 2px 2px 6px 0px rgba(4, 0, 14, 0.14);
        color: #ffffff;
    }
`;

const titleBoxStyle = css`
    position: relative;
    display: flex;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 56px;
    border-radius: 0px;
    padding: 14px;

    & .title {
        font-size: 18px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        color: #0c002c;
    }

    & .back-icon {
        position: absolute;
        left: 14px;
        top: 50%;
        transform: translateY(-50%);
        height: 20px;

        img {
            width: 14px;
            height: 14px;
        }
    }
`;
